
import Vue from 'vue';
import { mapState } from 'vuex';
import {
  DefaultPlatform,
  DefaultApplication,
} from '@/modules/library/constants';
import ExpansionPanels from '@/components/utils/ExpansionPanels.vue';

export default Vue.extend({
  components: {
    'expansion-panels': ExpansionPanels,
  },
  props: {
    isNewEntryOpen: {
      type: Boolean,
      default: true,
    },
    isSuperUser: {
      type: Boolean,
      default: true,
    },
    platformOptions: {
      type: Object,
      default: () => ({}),
    },
    availableApplications: {
      type: Array,
      default: () => [],
    },
    defaultPlatform: {
      type: String,
      default: DefaultPlatform,
    },
    defaultApplication: {
      type: String,
      default: DefaultApplication,
    },
  },
  data() {
    return {
      isTwoColRequired: this.isNewEntryOpen,
      applicationItems: this.availableApplications,
      platform: this.defaultPlatform,
      latestVersionApplication: this.defaultApplication,
    };
  },
  watch: {
    isNewEntryOpen(val) {
      (this as any).isTwoColRequired = val;
    },
    defaultPlatform(val) {
      if ((this as any).platform !== val) {
        (this as any).platform = val;
      }
    },
    DefaultApplication(val) {
      if ((this as any).latestVersionApplication !== val) {
        (this as any).latestVersionApplication = val;
      }
    },
  },
  computed: {
    ...mapState('version', ['latestVersion']),
    version() {
      const currentVersion = this.latestVersion[(this as any).latestVersionApplication];

      return currentVersion || {};
    },
  },
  methods: {
    getSupportDateString(dateString: string) {
      const localDate = new Date(dateString).toLocaleString();
      // toString() returns date time string in following formt:
      // "Tue Aug 03 2021 11:26:18 GMT+1000 (Australian Eastern Standard Time)"
      // Split using whitespace will get:
      // ["Tue", "Aug", "03", "2021", "11:27:12", "GMT+1000", "(Australian", "Eastern", "Standard", "Time)"]
      const gmtArray = new Date(dateString).toString().split(/\s/g);

      return `${localDate}, ${gmtArray[5]}<br>(ISO String: ${dateString})`;
    },
    updateVersionPlatform() {
      this.$emit('on-version-platform-change', {
        Platform: (this as any).platform,
      });
    },
    openEntryForm() {
      this.$emit('on-open-entry-form');
    },
    openAppDeeplinkDownloadUrlUpdateForm() {
      this.$emit('on-open-app-deeplink-updater-form')
    },
    updateApplication() {
      // In future when we are able to get full list of available applications, on select change we will able to retrieve new Latest Version details.
      this.$emit('on-version-update', {
        Application: (this as any).latestVersionApplication,
      })
    },
  },
})
